import { LegalClientActivityParam } from 'api/types/params';
import { isYes } from 'helpers';

import { CompanyActivityFormType } from '../../forms/companyActivityForm';

export const getActivityParam = (
  values: CompanyActivityFormType
): LegalClientActivityParam => ({
  activity: values.companyActivity.activity.value,
  isLargeEnterprise: isYes(values.companyActivity.isLargeEnterprise),
  isNominalHolder: isYes(values.companyActivity.isNominalHolder),
  requiresNominalHoldingSubaccount: isYes(
    values.companyActivity.requiresNominalHoldingSubaccount
  ),
  otherActivity: values.companyActivity.otherActivity,
});
